import DatetimeUtils from "../../gd/utils/datetime-utils";


export default class Vote {

    public userId          : ID
    public moment          : Moment

    constructor(userId: ID, moment: Moment) {
        this.userId        = userId
        this.moment        = moment
    }

    static initFromJson(data:JSONObject):Vote {
        return new Vote(
            data.userId as ID,
            DatetimeUtils.datetimeToMoment(data.moment as string)
        )
    }

    toJSON():JSONObject {
        return {
            userId      : this.userId,
            moment      : DatetimeUtils.momentToUTCISODatetime(this.moment)
        }
    }

}